import { createReducer } from '@reduxjs/toolkit';

import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import {
  backwardContractProgressStep,
  contractProgressContractLoadSuccess,
  contractProgressStepChange,
  forwardContractProgressStep,
  initializeContractProgress,
} from '@app/store/contract-progress/actions';

import ContractProgressStep from '../ContractProgressStep';

type ContractProgressStepState = {
  order: Array<ContractProgressStep>;
  currentStepIndex: number;
};

const initialState: ContractProgressStepState = {
  order: [],
  currentStepIndex: 0,
};

const reducer = createReducer(initialState, (builder) =>
  builder
    .addCase(contractProgressStepChange, (state, action) => {
      const currentStepIndex = state.order.findIndex((v) => v === action.payload);
      state.currentStepIndex = currentStepIndex;
    })
    .addCase(forwardContractProgressStep, (state) => {
      if (state.currentStepIndex < state.order.length - 1) {
        state.currentStepIndex += 1;
      }
    })
    .addCase(backwardContractProgressStep, (state) => {
      if (state.currentStepIndex > 0) {
        state.currentStepIndex -= 1;
      }
    })
    .addCase(
      CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
      (_state, action: ReturnType<typeof contractProgressContractLoadSuccess>) => {
        const order: ContractProgressStep[] = [];
        if (!action.payload.isReSigner) {
          order.push(ContractProgressStep.PREVIEW);
        }

        order.push(ContractProgressStep.FIELD_INSERT);

        if (action.payload.hasSignerAttachment) {
          order.push(ContractProgressStep.ATTACHMENT);
        }

        if (action.payload.contractLinkId && action.payload.hasAuthenticationRequest) {
          order.push(ContractProgressStep.AUTHENTICATION);
        }

        order.push(ContractProgressStep.COMPLETE);

        return {
          order,
          currentStepIndex: 0,
        };
      }
    )
    .addCase(initializeContractProgress, () => initialState)
    .addCase(CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST, () => initialState)
);

export default reducer;
